import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Radio } from './Radio';
var RadioGroup = function (props) {
    var options = props.options, selectedOption = props.selectedOption, onChange = props.onChange, className = props.className, labelClassName = props.labelClassName, isDisabled = props.isDisabled;
    return (React.createElement("div", { className: twMerge('flex flex-row', className) }, options.map(function (option) { return (React.createElement("label", { key: option.value, className: "flex items-center" },
        React.createElement(Radio, { option: option, isSelected: selectedOption.value === option.value, onChange: function () { return onChange(option); }, isDisabled: isDisabled, inputClassName: "mr-3" }),
        React.createElement("span", { className: twMerge('text-common-penguin', labelClassName) }, option.label))); })));
};
export default RadioGroup;
